import requestAnimationFrame from "GesagtGetan.Basic/Resources/Private/Assets/Scripts/requestAnimationFrame";

let windowHeight = window.innerHeight;
let isScroll = false;
let latestScroll = 0;
let scroll = null;
let swiper = null;
let pagination = null;

function updateWindowHeight() {
    windowHeight = window.innerHeight;
}

function checkScroll() {
    if (!isScroll) {
        requestAnimationFrame(update);
    }
    isScroll = true;
}

function update() {
    let currentScroll = latestScroll / 4;
    let factor = 4;
    isScroll = false;

    swiper.style.transform = `translate3d(0,${currentScroll}px,0)`;
    pagination.style.transform = `translate3d(0,-${currentScroll}px,0)`;
}

export default function() {
    scroll = document.querySelector(".swiper-scroll");

    if (scroll) {
        swiper = scroll.querySelector(".swiper-container");
        pagination = scroll.querySelector(".swiper-pagination");

        window.addEventListener(
            "scroll",
            () => {
                latestScroll = window.scrollY;
                checkScroll();
            },
            false
        );
        window.addEventListener("resize", updateWindowHeight, false);
    }
}
